const RECENT_ACTIONS_PREFIX = "recent-action-";

const isRecentActionId = (id: string) => {
  return id.startsWith(RECENT_ACTIONS_PREFIX);
};

export const makeRecentActionId = (actionId: string) => {
  if (isRecentActionId(actionId)) {
    return actionId;
  }

  return `${RECENT_ACTIONS_PREFIX}${actionId}`;
};

export const deconstructRecentActionId = (id: string) => {
  return id.replace(RECENT_ACTIONS_PREFIX, "");
};

export const makeSubListItemId = (bucketId: string, itemId: string) => {
  return `${bucketId}-${itemId}`;
};
